/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Attribute } from './attribute';


export interface BusinessObjectDefinitionCreateRequest { 
    /**
     * The name of a valid Namespace known by the system
     */
    namespace: string;
    /**
     * The name for this Business Object Definition
     */
    businessObjectDefinitionName: string;
    /**
     * The name of a valid Data Provider known by the system
     */
    dataProviderName: string;
    /**
     * An optional Department code
     */
    departmentCode?: string;
    /**
     * An optional description
     */
    description?: string;
    /**
     * An optional business friendly name
     */
    displayName?: string;
    /**
     * Custom user-defined metadata associated with this Business Object Definition. \"name\" is the attribute name (i.e. the key) and                   \"value\" is the attribute value                
     */
    attributes?: Array<Attribute>;
}
